import clsx from 'clsx';
import styles from './Avatar.module.css';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

/** Number of avatar tints defined in the theme (`--color-avatar-1…8`). */
const TINT_COUNT = 8;

const initialsOf = (name: string): string => {
  const words = name.trim().split(/\s+/u).filter(Boolean);
  const letters = words.length > 1 ? [words[0], words[words.length - 1]] : [words[0]];
  return letters
    .map((word) => (word ? Array.from(word)[0] : ''))
    .join('')
    .toLocaleUpperCase();
};

/** Same name → same tint on every screen and for every viewer. */
const tintOf = (seed: string): number => {
  let hash = 0;
  for (const char of seed) hash = (hash * 31 + (char.codePointAt(0) ?? 0)) >>> 0;
  return (hash % TINT_COUNT) + 1;
};

export interface AvatarProps {
  readonly name: string;
  /** Stable identity for the tint; defaults to the name. */
  readonly seed?: string | undefined;
  readonly size?: AvatarSize | undefined;
  readonly className?: string | undefined;
}

export const Avatar = ({ name, seed, size = 'md', className }: AvatarProps) => (
  <span
    className={clsx(styles.avatar, styles[size], className)}
    style={{ background: `var(--color-avatar-${tintOf(seed ?? name)})` }}
    aria-hidden="true"
  >
    {initialsOf(name) || '·'}
  </span>
);
